import { AbstractHistogram } from 'hdr-histogram-js'
import * as React from 'react'
import { Report } from '../domain/Report'
import LargeNumber from '../helper/large-number'
import Memory from '../helper/memory'
import Milliseconds from '../helper/milliseconds'
import Percent from '../helper/percent'

interface Props {
    report?: Report<AbstractHistogram>
}

export class GraphStats extends React.PureComponent<Props> {
    public render() {
        const { report } = this.props

        if (!report) {
            return null
        }

        // sometimes we have slices.total, sometimes just slices[service]
        const slice = report.slices[Object.keys(report.slices)[0]]

        return (
            <ul className="nav navbar-nav navbar-right navbar-numbers">
                {!report.histogram ? null : (
                    <li>
                        <a href="">
                            <Milliseconds value={report.histogram.getValueAtPercentile(95) * 1000} />
                            <small>95% Percentile</small>
                        </a>
                    </li>
                )}
                {slice.memory && slice.memory > 0 ? (
                    <li>
                        <a>
                            <Memory value={slice.memory * 1024} />
                            <small>Max Memory</small>
                        </a>
                    </li>
                ) : null}
                <li>
                    <a href="">
                        <LargeNumber value={slice.requests} />
                        <small>Requests</small>
                    </a>
                </li>
                {slice.pageCache.hits > 0 ? (
                    <li>
                        <a href="">
                            <Percent value={slice.pageCache.hits / (slice.pageCache.hits + slice.pageCache.misses)} />
                            <small>Page Cache Hit Rate</small>
                        </a>
                    </li>
                ) : null}
                {slice.crawlers > 0 ? (
                    <li>
                        <a href="">
                            <Percent value={slice.crawlers / slice.requests} />
                            <small>Crawlers/Bots</small>
                        </a>
                    </li>
                ) : null}
                <li>
                    <a href="">
                        <Percent value={slice.errorRate / 100} class="error" />
                        <small>Failures</small>
                    </a>
                </li>
            </ul>
        )
    }
}
